import { ApiProductsquerySalesarticlesCategoryCategoryIdGet$Params } from '@api/fn/sales-articles/api-productsquery-salesarticles-category-category-id-get';

export class LoadHighlightedSalesArticles {
  static readonly type = '[Box-Deals] LoadHighlightedSalesArticles';
}

export class LoadHighlightedCategories {
  static readonly type = '[Box-Deals] LoadHighlightedCategories';
}

export class LoadSalesArticlesByCategoryStarted {
  static readonly type = '[Box-Deals] LoadSalesArticlesByCategoryStarted';

  constructor(public payload: ApiProductsquerySalesarticlesCategoryCategoryIdGet$Params) {}
}

export class LoadSalesArticlesByCategoryDone {
  static readonly type = '[Box-Deals] LoadSalesArticlesByCategoryDone';

  constructor(public payload: ApiProductsquerySalesarticlesCategoryCategoryIdGet$Params) {}
}

export class LoadCategories {
  static readonly type = '[Box-Deals] LoadCategories';
}

export class ClearSalesArticlePagePosition {
  static readonly type = '[Box-Deals] ClearSalesArticlePagePosition';
}

export class LoadSalesArticlesByBrand {
  static readonly type = '[Box-Deals] LoadSalesArticlesByBrand';

  constructor(public payload: string) {}
}

export class LoadPopular {
  static readonly type = '[Box-Deals] LoadPopular';
}

export class LoadLatest {
  static readonly type = '[Box-Deals] LoadLatest';
}

export class LoadPopularByCategory {
  static readonly type = '[Box-Deals] LoadPopularByCategory';

  constructor(public id: string) {}
}

export class LoadPopularForMainCategory {
  static readonly type = '[Box-Deals] LoadPopularForMainCategory';

  constructor(public categoryId: string) {}
}

export class LoadTemporaryDiscounts {
  static readonly type = '[Box-Deals] LoadTemporaryDiscounts';

  constructor() {}
}
